var _Path, _Text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Text } from "react-native-svg";
var SvgSeekBackward15 = function SvgSeekBackward15(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    fill: "none"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M480-80q75 0 140.5-28.5t114-77q48.5-48.5 77-114T840-440q0-75-28.5-140.5t-77-114q-48.5-48.5-114-77T480-800h-6l62-62-56-58-160 160 160 160 56-58-62-62h6q117 0 198.5 81.5T760-440q0 117-81.5 198.5T480-160q-117 0-198.5-81.5T200-440h-80q0 75 28.5 140.5t77 114q48.5 48.5 114 77T480-80Z",
    fill: "currentColor"
  })), _Text || (_Text = /*#__PURE__*/React.createElement(Text, {
    fontWeight: "bold",
    x: 290.3,
    y: -318.8,
    fontFamily: "inherit",
    fontSize: 300,
    fill: "currentColor"
  }, "15")));
};
export default SvgSeekBackward15;